import { render, staticRenderFns } from "./Diagramme.vue?vue&type=template&id=5a665d52&"
import script from "./Diagramme.vue?vue&type=script&lang=ts&"
export * from "./Diagramme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports